/* Black November Exclusive: keyboard + mouse + FREE mousepad builder. Keyboard picker has All / Mechanical / Magnetic tabs. 'You save' shows only once keyboard, mouse and mousepad are chosen. */
(function () {
  function init(root) {
    if (root.__ftbn) return;
    root.__ftbn = true;

    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var padMax = Number(root.dataset.padMax || 1800);
    var giftId = Number(root.dataset.giftId || 0);
    var giftValue = Number(root.dataset.giftValue || 0);
    var ORDER = ['kb', 'mouse', 'pad'];
    var SLOTS = {
      kb: { handle: root.dataset.kb, title: 'Choose your keyboard', word: 'keyboard' },
      mouse: { handle: root.dataset.mouse, title: 'Choose your mouse', word: 'mouse' },
      pad: { handle: root.dataset.pad, title: 'Choose your FREE mousepad', word: 'mousepad' }
    };
    var state = { kb: null, mouse: null, pad: null };
    var cache = {};
    var loading = {};
    var cur = null;
    var pending = null;
    var busy = false;
    var tabSel = 'all';
    var groups = null;
    var groupsP = null;

    var dlg = root.querySelector('[data-ftbn-dlg]');
    var dlgTitle = root.querySelector('[data-ftbn-dlg-title]');
    var grid = root.querySelector('[data-ftbn-grid]');
    var q = root.querySelector('[data-ftbn-q]');
    var foot = root.querySelector('[data-ftbn-foot]');
    var cta = root.querySelector('[data-ftbn-cta]');
    var totalEl = root.querySelector('[data-ftbn-total]');
    var saveEl = root.querySelector('[data-ftbn-save]');
    var statusEl = root.querySelector('[data-ftbn-status]');

    if (!document.getElementById('ftbn-tabs-css')) {
      var st = document.createElement('style');
      st.id = 'ftbn-tabs-css';
      st.textContent = '.ftbn__tabs{flex:0 0 auto;display:flex;align-items:center;gap:8px;min-height:48px;margin:0 16px 12px;padding:2px 0;overflow-x:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch}.ftbn__tabs::-webkit-scrollbar{display:none}.ftbn__tabs[hidden]{display:none}.ftbn__tab{flex:0 0 auto;min-height:42px;padding:9px 16px;border:1px solid #cfcfcf;border-radius:999px;background:#fff;color:#111;font:inherit;font-size:.86rem;font-weight:700;line-height:1.2;white-space:nowrap;cursor:pointer}.ftbn__tab small{margin-inline-start:6px;font-size:.74rem;font-weight:600;opacity:.65}.ftbn__tab.is-sel{background:#111;border-color:#111;color:#fff}@media(min-width:700px){.ftbn__tabs{margin:0 20px 12px}}';
      document.head.appendChild(st);
    }
    var tabsEl = document.createElement('div');
    tabsEl.className = 'ftbn__tabs';
    tabsEl.setAttribute('role', 'tablist');
    tabsEl.hidden = true;
    grid.parentNode.insertBefore(tabsEl, grid);

    function money(c) {
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(c / 100); }
      catch (e) { return '$' + (c / 100).toFixed(2); }
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function sized(u, w) {
      if (!u) return '';
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function normalize(list, slot) {
      return list.map(function (p) {
        var title = String(p.title || '');
        var tl = title.toLowerCase();
        var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
        tags = tags.map(function (t) { return String(t).trim().toLowerCase(); });
        if (String(p.product_type || '').toLowerCase() === 'bundle' || tags.indexOf('bundles') > -1 || tags.indexOf('ft-gift') > -1 || tl.indexOf('bundle') > -1 || tl.indexOf('free gift') > -1) return null;
        var pimg = p.images && p.images[0] ? p.images[0].src : '';
        var imgs = p.images || [];
        function vimgOf(v) {
          var m = imgs.filter(function (im) { return (im.variant_ids || []).indexOf(v.id) > -1; })[0] ||
            imgs.filter(function (im) { return v.image_id && im.id === v.image_id; })[0];
          return (m && m.src) || (v.featured_image && v.featured_image.src) || pimg;
        }
        var vs = (p.variants || []).filter(function (v) { return v.available; }).map(function (v) {
          return { id: v.id, t: v.title, p: Math.round(parseFloat(v.price) * 100), i: vimgOf(v) };
        });
        if (slot === 'pad') vs = vs.filter(function (v) { return v.p <= padMax; });
        if (!vs.length) return null;
        return { id: p.id, n: title, i: pimg, v: vs };
      }).filter(Boolean);
    }

    function load(slot) {
      if (cache[slot]) return Promise.resolve(cache[slot]);
      if (loading[slot]) return loading[slot];
      loading[slot] = fetch(base + 'collections/' + encodeURIComponent(SLOTS[slot].handle) + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
        .then(function (j) { cache[slot] = normalize(j.products || [], slot); return cache[slot]; })
        .catch(function (e) { loading[slot] = null; throw e; });
      return loading[slot];
    }

    function loadGroups() {
      if (groupsP) return groupsP;
      function ids(h) {
        return fetch(base + 'collections/' + h + '/products.json?limit=250')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (j) { var o = {}; (j.products || []).forEach(function (p) { o[p.id] = 1; }); return o; })
          .catch(function () { return {}; });
      }
      groupsP = Promise.all([ids('mechanical-keyboards'), ids('hall-effect-keyboards')]).then(function (a) {
        groups = { mech: a[0], mag: a[1] };
        return groups;
      });
      return groupsP;
    }

    function inTab(p) {
      if (tabSel === 'all') return true;
      return !!(groups && groups[tabSel] && groups[tabSel][p.id]);
    }

    function renderTabs() {
      var list = cache[cur];
      if (cur !== 'kb' || !list || !groups) { tabsEl.hidden = true; tabsEl.innerHTML = ''; return; }
      var cm = list.filter(function (p) { return groups.mech[p.id]; }).length;
      var cg = list.filter(function (p) { return groups.mag[p.id]; }).length;
      var tabs = [{ k: 'all', l: 'All keyboards', n: list.length }];
      if (cm) tabs.push({ k: 'mech', l: 'Mechanical', n: cm });
      if (cg) tabs.push({ k: 'mag', l: 'Magnetic', n: cg });
      if (tabs.length < 2) { tabsEl.hidden = true; tabsEl.innerHTML = ''; return; }
      tabsEl.hidden = false;
      tabsEl.innerHTML = tabs.map(function (t) {
        return '<button type="button" role="tab" class="ftbn__tab' + (t.k === tabSel ? ' is-sel' : '') + '" data-tab="' + t.k + '" aria-selected="' + (t.k === tabSel) + '">' + t.l + '<small>' + t.n + '</small></button>';
      }).join('');
    }

    function priceLabel(p) {
      var ps = p.v.map(function (v) { return v.p; });
      var lo = Math.min.apply(null, ps);
      var hi = Math.max.apply(null, ps);
      if (cur === 'pad') return '<s>' + money(hi) + '</s> <b class="ftbn__free">FREE</b>';
      return (lo === hi ? '' : 'From ') + money(lo);
    }

    function renderGrid() {
      var list = cache[cur];
      if (!list) return;
      var term = (q.value || '').trim().toLowerCase();
      var shown = list.filter(function (p) {
        return (!term || p.n.toLowerCase().indexOf(term) > -1) && (cur !== 'kb' || inTab(p));
      });
      if (!shown.length) {
        grid.innerHTML = '<p class="ftbn__msg">' + (term ? 'No matches. Try another name.' : 'Nothing available right now.') + '</p>';
        return;
      }
      var selId = pending ? pending.p.id : (state[cur] ? state[cur].p.id : 0);
      grid.innerHTML = shown.map(function (p) {
        var sel = p.id === selId;
        var pv = sel && pending && pending.p.id === p.id ? p.v[pending.vi] : null;
        var cimg = (pv && pv.i) || p.i;
        return '<button type="button" class="ftbn__card' + (sel ? ' is-sel' : '') + '" data-pid="' + p.id + '" aria-pressed="' + sel + '">' +
          '<span class="ftbn__card-img">' + (cimg ? '<img src="' + esc(sized(cimg, 300)) + '" alt="" loading="lazy" width="150" height="150">' : '') + '</span>' +
          '<span class="ftbn__card-name">' + esc(p.n) + '</span>' +
          '<span class="ftbn__card-price">' + priceLabel(p) + '</span>' +
          (p.v.length > 1 ? '<span class="ftbn__card-meta">' + p.v.length + ' options</span>' : '') +
          '</button>';
      }).join('');
    }

    function renderFoot() {
      if (!pending || pending.p.v.length < 2) { foot.hidden = true; foot.innerHTML = ''; return; }
      var p = pending.p;
      foot.hidden = false;
      foot.innerHTML = '<p class="ftbn__foot-name">' + esc(p.n) + '</p>' +
        '<div class="ftbn__chips">' + p.v.map(function (v, i) {
          var on = i === pending.vi;
          return '<button type="button" class="ftbn__chip' + (on ? ' is-sel' : '') + '" data-vi="' + i + '" aria-pressed="' + on + '">' + esc(v.t) + '</button>';
        }).join('') + '</div>' +
        '<button type="button" class="ftbn__pick" data-ftbn-commit>Select · ' + (cur === 'pad' ? 'FREE' : money(p.v[pending.vi].p)) + '</button>';
    }

    function openPicker(slot) {
      cur = slot;
      tabSel = 'all';
      tabsEl.hidden = true;
      tabsEl.innerHTML = '';
      pending = state[slot] ? { p: state[slot].p, vi: Math.max(0, state[slot].p.v.indexOf(state[slot].v)) } : null;
      dlgTitle.textContent = SLOTS[slot].title;
      q.value = '';
      grid.innerHTML = '<p class="ftbn__msg">Loading products…</p>';
      renderFoot();
      if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else { dlg.setAttribute('open', ''); }
      var work = slot === 'kb' ? Promise.all([load(slot), loadGroups()]) : load(slot);
      work.then(function () { if (cur === slot) { renderTabs(); renderGrid(); renderFoot(); } })
        .catch(function () { if (cur === slot) grid.innerHTML = '<p class="ftbn__msg">Could not load products. Please try again.</p>'; });
    }

    function closePicker() {
      if (typeof dlg.close === 'function' && dlg.open) dlg.close(); else dlg.removeAttribute('open');
    }

    function commit() {
      if (!pending) return;
      var slot = cur;
      state[slot] = { p: pending.p, v: pending.p.v[pending.vi] || pending.p.v[0] };
      pending = null;
      closePicker();
      update();
      var next = ORDER.filter(function (s) { return !state[s]; })[0];
      if (next) setTimeout(function () { openPicker(next); }, 220);
    }

    function update() {
      ORDER.forEach(function (slot) {
        var btn = root.querySelector('[data-slot="' + slot + '"]');
        if (!btn) return;
        var s = state[slot];
        btn.classList.toggle('is-set', !!s);
        var img = btn.querySelector('[data-slot-img]');
        var name = btn.querySelector('[data-slot-name]');
        var price = btn.querySelector('[data-slot-price]');
        var act = btn.querySelector('[data-slot-act]');
        if (s) {
          var vimg = s.v.i || s.p.i;
          img.innerHTML = vimg ? '<img src="' + esc(sized(vimg, 160)) + '" alt="" width="56" height="56">' : '';
          name.textContent = s.p.n + (s.v.t && s.v.t !== 'Default Title' ? ' · ' + s.v.t : '');
          price.innerHTML = slot === 'pad' ? '<s>' + money(s.v.p) + '</s> <b class="ftbn__free">FREE</b>' : money(s.v.p);
          act.textContent = 'Change';
        } else {
          img.innerHTML = '';
          name.textContent = name.dataset.empty;
          price.innerHTML = slot === 'pad' ? '<b class="ftbn__free">FREE</b> · up to ' + money(padMax) : '';
          act.textContent = 'Choose';
        }
      });

      var paid = (state.kb ? state.kb.v.p : 0) + (state.mouse ? state.mouse.v.p : 0);
      var ready = !!(state.kb && state.mouse && state.pad);
      var save = (state.pad ? state.pad.v.p : 0) + (state.pad && giftId ? giftValue : 0);
      totalEl.textContent = money(paid);
      saveEl.textContent = ready && save ? 'You save ' + money(save) : '';
      saveEl.style.display = ready && save ? '' : 'none';
      var missing = ORDER.filter(function (s) { return !state[s]; }).map(function (s) { return SLOTS[s].word; });
      cta.textContent = ready ? 'Add bundle to cart · ' + money(paid) : 'Choose your ' + missing[0];
      cta.classList.toggle('is-ready', ready);
    }

    function addToCart() {
      var ready = !!(state.kb && state.mouse && state.pad);
      if (!ready) { openPicker(ORDER.filter(function (s) { return !state[s]; })[0]); return; }
      if (busy) return;
      busy = true;
      cta.disabled = true;
      cta.setAttribute('aria-busy', 'true');
      statusEl.textContent = 'Adding your bundle…';
      var items = ORDER.map(function (s) { return { id: state[s].v.id, quantity: 1, properties: { _offer: 'black-november-setup', _ft_role: s } }; });
      if (giftId) items.push({ id: giftId, quantity: 2, properties: { 'FREE GIFT': '2 packs Mouse skates · 5× faster glide', _offer: 'black-november-setup' } });
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add the bundle.'); return j; }); })
        .then(function (json) {
          var ts = window.themeVariables && window.themeVariables.settings;
          if (ts && (ts.pageType === 'cart' || ts.cartType === 'page')) { window.location.href = base + 'cart'; return null; }
          return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = json.sections;
            root.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            statusEl.textContent = 'Bundle added to your cart.';
          });
        })
        .catch(function (e) { statusEl.textContent = e.message || 'Could not add the bundle. Please try again.'; })
        .then(function () { busy = false; cta.disabled = false; cta.removeAttribute('aria-busy'); });
    }

    root.addEventListener('click', function (e) {
      var slotBtn = e.target.closest('[data-slot]');
      if (slotBtn) { openPicker(slotBtn.getAttribute('data-slot')); return; }
      if (e.target.closest('[data-ftbn-cta]')) { addToCart(); return; }
      if (e.target.closest('[data-ftbn-close]')) { closePicker(); return; }
      if (e.target === dlg) { closePicker(); return; }
      var tab = e.target.closest('[data-tab]');
      if (tab) {
        tabSel = tab.getAttribute('data-tab');
        renderTabs();
        renderGrid();
        grid.scrollTop = 0;
        return;
      }
      var card = e.target.closest('[data-pid]');
      if (card && cache[cur]) {
        var id = Number(card.getAttribute('data-pid'));
        var p = cache[cur].filter(function (x) { return x.id === id; })[0];
        if (!p) return;
        pending = { p: p, vi: 0 };
        if (p.v.length === 1) { commit(); return; }
        renderGrid();
        renderFoot();
        foot.scrollIntoView({ block: 'nearest' });
        return;
      }
      var chip = e.target.closest('[data-vi]');
      if (chip && pending) {
        pending.vi = Number(chip.getAttribute('data-vi'));
        renderFoot();
        var vi = pending.p.v[pending.vi] && pending.p.v[pending.vi].i;
        var cimg = vi && grid.querySelector('[data-pid="' + pending.p.id + '"] img');
        if (cimg) { cimg.removeAttribute('srcset'); cimg.src = sized(vi, 300); }
        return;
      }
      if (e.target.closest('[data-ftbn-commit]')) commit();
    });

    root.addEventListener('pointerenter', function (e) {
      var slotBtn = e.target.closest && e.target.closest('[data-slot]');
      if (slotBtn) {
        var s = slotBtn.getAttribute('data-slot');
        load(s).catch(function () {});
        if (s === 'kb') loadGroups();
      }
    }, true);

    q.addEventListener('input', renderGrid);
    update();
  }

  function run() { document.querySelectorAll('[data-ftbn]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
